import request from './request'

/**
 * 公共函数get请求
 */
export function get(path, query) {
  return request({
    method: 'get',
    url: path,
    params: query
  })
}

/**
 * 公共函数post请求
 */
export function post(path, query) {
  return request({
    method: 'post',
    url: path,
    params: query
  })
}

/**
 * 公共函数excute请求
 */
export function execute(path, data) {
  return request({
    method: 'post',
    url: path,
    data
  })
}

export function getUrlStr(name) {
  /**
   * 获取地址栏参数
   */
  let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
  // console.log("url:" + location.search.substr(1))
  if (reg.test(location.search.substr(1))) {
    return unescape(RegExp.$2.replace(/\+/g, " "))
  }
  return undefined
}